(() => {
  if (window.location.pathname !== '/products/the-revere') return;

  const init = async () => {
    const form = document.getElementById('pdp-product-form');
    if (!form) return;

    let product;
    try {
      const res = await fetch('/products/the-revere.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      product = await res.json();
    } catch (_) { return; }

    const hiddenId = form.querySelector('[data-pdp-variant-id]');
    const priceEl = document.querySelector('[data-pdp-price]');
    const stickyPriceEl = document.querySelector('[data-pdp-sticky-price]');
    const swatches = [...document.querySelectorAll('[data-pdp-swatch]')];
    const sizes = [...document.querySelectorAll('[data-pdp-size]')];

    const selectedColor = () => {
      const selected = swatches.find(s => s.getAttribute('aria-checked') === 'true' || s.classList.contains('pdp-swatch--selected'));
      return selected ? selected.dataset.optionValue : null;
    };

    const selectedSize = () => {
      const checked = sizes.find(s => s.checked);
      return checked ? checked.value : null;
    };

    const findVariant = (color, size) => product.variants.find(v => v.options[0] === color && v.options[1] === size);

    const money = cents => {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(cents / 100); }
      catch (_) { return '$' + (cents / 100).toFixed(2); }
    };

    const setVariant = variant => {
      if (!variant || !variant.available) return;
      if (hiddenId) hiddenId.value = variant.id;
      const formatted = money(variant.price);
      if (priceEl) priceEl.textContent = formatted;
      if (stickyPriceEl) stickyPriceEl.textContent = formatted;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };

    const refreshSizes = () => {
      const color = selectedColor();
      if (!color) return;
      sizes.forEach(input => {
        const variant = findVariant(color, input.value);
        const available = !!(variant && variant.available);
        input.disabled = !available;
        input.setAttribute('aria-disabled', available ? 'false' : 'true');
        input.dataset.variantId = variant ? variant.id : '';
        const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label) label.classList.toggle('pdp-pill--unavailable', !available);
      });
      let size = selectedSize();
      let variant = size ? findVariant(color, size) : null;
      if (!variant || !variant.available) {
        const first = sizes.find(i => !i.disabled);
        if (first) { first.checked = true; size = first.value; variant = findVariant(color, size); }
      }
      setVariant(variant);
    };

    sizes.forEach(input => input.addEventListener('change', () => {
      const variant = findVariant(selectedColor(), input.value);
      setVariant(variant);
    }));

    swatches.forEach(sw => sw.addEventListener('click', () => setTimeout(refreshSizes, 0)));

    refreshSizes();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
